<template>
  <LumpSumTradeRowParentItem
    v-if="tradeItem.has_children"
    :trade="$props.trade"
    :claim="$props.claim"
    :trade-item="$props.tradeItem"
    :project-id="$props.projectId"
    :package-id="$props.packageId"
    :can-edit-certified="$props.canEditCertified"
    :can-edit-claim="$props.canEditClaim"
    :lite-mode="$props.liteMode"
    :show-percentages="$props.showPercentages"
    :show-forecasts="$props.showForecasts"
    :depth="$props.depth"
  />

  <LumpSumTradeRowLeafItem
    v-else-if="packageTradeItem"
    :trade="$props.trade"
    :claim="$props.claim"
    :trade-item="$props.tradeItem"
    :project-id="$props.projectId"
    :package-trade-item="packageTradeItem"
    :can-edit-certified="$props.canEditCertified"
    :can-edit-claim="$props.canEditClaim"
    :lite-mode="$props.liteMode"
    :show-percentages="$props.showPercentages"
    :show-forecasts="$props.showForecasts"
    :depth="$props.depth"
  />
</template>

<script setup lang="ts">
import Claim from '@/models/Claim';
import PackageTradeItem from '@/models/PackageTradeItem';
import Trade from '@/models/Trade';
import TradeItem from '@/models/TradeItem';
import { usePackageTradeItemsStore } from '@/store/packageTradeItems';
import { computed } from 'vue';
import LumpSumTradeRowLeafItem from './LumpSumTradeRowLeafItem.vue';
import LumpSumTradeRowParentItem from './LumpSumTradeRowParentItem.vue';

const props = withDefaults(
  defineProps<{
    trade?: Trade;
    claim: Claim;
    tradeItem: TradeItem;
    projectId: string;
    packageId: string;
    canEditCertified: boolean;
    canEditClaim: boolean;
    liteMode?: boolean;
    showPercentages?: boolean;
    showForecasts?: boolean;
    depth?: number;
  }>(),
  {
    liteMode: false,
    depth: 0,
  },
);

const packageTradeItemsStore = usePackageTradeItemsStore();

const packageTradeItem = computed(() => {
  return packageTradeItemsStore.models
    .where('package_id', parseInt(props.packageId))
    .where('trade_item_id', props.tradeItem.id)
    .with('wbs_code')
    .with('trade_item')
    .first();
});
</script>

<style scoped></style>
